import { Button, Stack, Typography, useTheme } from '@mui/material';
import ServiceProviderWrapper from '../../../markers/ServiceProvider/ServiceProviderWrapper';
import MapLib from '../../../lib/MapLib';

function TitleSection({ sp, location, index, isAssignedOrAcceptedSP }) {
  const theme = useTheme();

  return (
    <Stack direction="row" spacing={1}>
      <ServiceProviderWrapper
        MapLib={MapLib}
        theme={theme}
        serviceProvider={sp}
        onClickHandler={null}
        index={index}
        // Different style for assigned or accepted
        type={
          isAssignedOrAcceptedSP(sp, location)
            ? 'ASSIGNED_OR_ACCEPTED'
            : 'GENERIC'
        }
        nonGenericTypeHidePointer
        location={location}
        contact={location.primaryContact}
      />
      <Stack direction="column" spacing={0.5}>
        <Button
          variant="text"
          color="primary"
          sx={{
            fontSize: '1.2em',
            fontWeight: 'bold',
            p: 0,
            justifyContent: 'start',
            textTransform: 'none',
            lineHeight: '1.3em',
          }}
          component="a"
          href={`/serviceproviders/edit/${sp?.id}`}
          target="_blank"
          rel="noopener noreferrer">
          {sp?.name}
        </Button>
        <Button
          component="a"
          href={`/serviceproviders/edit/${sp?.id}/locations/${location?.id}`}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            fontSize: '1.2em',
            fontWeight: 'bold',
            p: 0,
            justifyContent: 'start',
            textTransform: 'none',
            lineHeight: '1.3em',
          }}>
          <Typography
            sx={{ mt: -0.5 }}
            fontWeight="bold"
            variant="subtitle2"
            component="span"
            color="text.primary">
            {location?.name}
          </Typography>
        </Button>
      </Stack>
    </Stack>
  );
}

export default TitleSection;
